module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/order_06-8b878b355cafcf75a504be6ef6a5c701.png";